module.exports = __webpack_public_path__ + "img/favicon256.86622bdb.png";